import { Injectable } from '@angular/core';
import { ServiceApi } from '../genericApi/service-api';
import { ConfigService } from '../../Core/Config/services/config.service';
import { ConfigModel } from '../../Core/Config/models/config.model';
import { Observable } from 'rxjs';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { TargetingAccountPreferencesApiModel } from './model/targeting-account-preferences.api.model';

@Injectable()
export class TargetingPreferencesApi {
    private apiUrl: string;

    constructor(
        private serviceApi: ServiceApi,
        private configurationService: ConfigService
    ) {
        const config: ConfigModel = this.configurationService.getConfig();

        this.apiUrl = config?.apiUrl;
    }

    public getOwnAccountPreferences(): Observable<TargetingAccountPreferencesApiModel> {
        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<TargetingAccountPreferencesApiModel>(
            '/targetingpreferences/account/mine',
            null,
            HttpVerbsEnum.GET
        );
    }

    public getAccountPreferences(accountId: number): Observable<TargetingAccountPreferencesApiModel> {
        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<TargetingAccountPreferencesApiModel>(
            `/targetingpreferences/account/${accountId}`,
            null,
            HttpVerbsEnum.GET,
        );
    }

    public updateAccountPreferences(
        accountId: number,
        preferences: TargetingAccountPreferencesApiModel): Observable<void> {
        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<void>(
            `/targetingpreferences/account/${accountId}`,
            preferences,
            HttpVerbsEnum.PUT
        );
    }

    public purchaseRecipients(amount: number): Observable<void> {
        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<void>(
            '/targetingpreferences/account/mine/purchaserecipients?amount=' + amount,
            null,
            HttpVerbsEnum.POST
        );
    }
}
